<template>
  <Announcement
    id="maintenance"
    :title="title"
    :message="maintenanceMessage"
    :additional-info="additionalInfo"
    :additional-info-schedule="additionalInfoSchedule"
    :collapsed="collapsed"
    @toggle="handleToggle"
  />
</template>

<script setup lang="ts">
import { computed, defineProps, defineEmits, ref, watch, onMounted } from 'vue';
import Announcement from './index.vue';
import { MAINTENANCE_MESSAGE } from '@/utils/constants';
import { toggleAnnouncementState } from '@/services/announcement.service';

const props = defineProps({
  title: {
    type: String,
    default: 'メンテナンスのお知らせ',
  },
  startDate: {
    type: String,
    required: true,
  },
  startTime: {
    type: String,
    required: true,
  },
  endTime: {
    type: String,
    required: true,
  },
  additionalInfo: {
    type: String,
    default: MAINTENANCE_MESSAGE.ADDITIONAL_INFO,
  },
  additionalInfoSchedule: {
    type: String,
    default: '',
  },
  isCollapsed: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(['toggle']);

// コンポーネント内の状態
const collapsed = ref(props.isCollapsed);

// 親コンポーネントのisCollapsedプロパティが変更されたら反映
watch(
  () => props.isCollapsed,
  (newVal) => {
    collapsed.value = newVal;
  }
);

// 初期表示時に状態を設定
onMounted(() => {
  // CookieからcollapsedのデフォルトはfalseだがisCollapsedがtrueならそちらを優先
  collapsed.value = props.isCollapsed;
});

// 開閉状態が変更されたときのハンドラ
const handleToggle = (data: { isCollapsed: boolean }) => {
  collapsed.value = data.isCollapsed;
  emit('toggle', { id: 'maintenance', isCollapsed: data.isCollapsed });
};

const maintenanceMessage = computed(() => {
  return `以下の日時にて、メンテナンスを実施させていただきます。
  <span class="fw-bold mb-0 size-16">${props.startDate} ${props.startTime}～${props.endTime}</span>
  <span class="error-message size-14 fw-bold">メンテナンス中はサイトへのアクセスができなくなりますのでご注意ください。</span>`;
});
</script>
